import { clubLandSetupPaths } from '../utils/clubLandSetup';
import './ClubLandSetupOverlay.css';

export function ClubLandSetupOverlay({ show, onChoose }) {
  if (!show) return null;
  return (
    <div className="club-land-setup" data-testid="club-land-setup" role="dialog" aria-label="Create club boundary">
      <div className="club-land-setup__card">
        <h2 className="club-land-setup__title">Create the club boundary</h2>
        <p className="club-land-setup__copy">
          Draw the property line by hand, or pick Alabama parcels. Either path saves the club map.
        </p>
        <div className="club-land-setup__actions">
          {clubLandSetupPaths().map((path) => (
            <button
              key={path.id}
              type="button"
              className="club-land-setup__btn"
              data-testid={`club-land-setup-${path.id}`}
              onClick={() => onChoose && onChoose(path.id)}
            >
              {path.label}
            </button>
          ))}
        </div>
      </div>
    </div>
  );
}

export default ClubLandSetupOverlay;
